module.exports = __webpack_public_path__ + "static/media/craft_failure_first.a91c0256.mp3";